export default __webpack_public_path__ + "static/media/020-gas-mask.87a3ffed.png";